{
  "LABEL_MGMT": {
    "HEADER": "Etiquetas",
    "HEADER_BTN_TXT": "Añadir etiqueta",
    "LOADING": "Obteniendo etiquetas",
    "DESCRIPTION": "Las etiquetas le ayudan a clasificar y priorizar conversaciones y clientes potenciales. Puede asignar una etiqueta a una conversación o contacto usando el panel lateral.",
    "LEARN_MORE": "Aprende más sobre etiquetas",
    "SEARCH_404": "No hay elementos que coincidan con esta consulta",
    "LIST": {
      "404": "No hay etiquetas disponibles en esta cuenta.",
      "TITLE": "Gestionar etiquetas",
      "DESC": "Las etiquetas permiten agrupar las conversaciones.",
      "TABLE_HEADER": {
        "NAME": "Nombre",
        "DESCRIPTION": "Descripción",
        "COLOR": "Color"
      }
    },
    "FORM": {
      "NAME": {
        "LABEL": "Nombre de la etiqueta",
        "PLACEHOLDER": "Nombre de la etiqueta",
        "REQUIRED_ERROR": "Nombre de la etiqueta es obligatorio",
        "MINIMUM_LENGTH_ERROR": "La longitud mínima es de 2 caracteres",
        "VALID_ERROR": "Sólo letras, números, guión y guión bajo son permitidos"
      },
      "DESCRIPTION": {
        "LABEL": "Descripción",
        "PLACEHOLDER": "Descripción de la etiqueta"
      },
      "COLOR": {
        "LABEL": "Color"
      },
      "SHOW_ON_SIDEBAR": {
        "LABEL": "Mostrar etiqueta en la barra lateral"
      },
      "EDIT": "Editar",
      "CREATE": "Crear",
      "DELETE": "Eliminar",
      "CANCEL": "Cancelar"
    },
    "SUGGESTIONS": {
      "TOOLTIP": {
        "SINGLE_SUGGESTION": "Añadir etiqueta a la conversación",
        "MULTIPLE_SUGGESTION": "Seleccionar esta etiqueta",
        "DESELECT": "Deseleccionar etiqueta",
        "DISMISS": "Descartar sugerencia"
      },
      "POWERED_BY": "AI",
      "DISMISS": "Descartar",
      "ADD_SELECTED_LABELS": "Asignar etiquetas seleccionadas",
      "ADD_SELECTED_LABEL": "Añadir etiqueta seleccionada",
      "ADD_ALL_LABELS": "Añadir todas las etiquetas",
      "SUGGESTED_LABELS": "Etiquetas sugeridas"
    },
    "ADD": {
      "TITLE": "Añadir etiqueta",
      "DESC": "Las etiquetas permiten agrupar las conversaciones.",
      "API": {
        "SUCCESS_MESSAGE": "Etiqueta añadida correctamente",
        "ERROR_MESSAGE": "Hubo un error, por favor inténtelo de nuevo"
      }
    },
    "EDIT": {
      "TITLE": "Editar etiqueta",
      "API": {
        "SUCCESS_MESSAGE": "Etiqueta actualizada correctamente",
        "ERROR_MESSAGE": "Hubo un error, por favor inténtelo de nuevo"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Eliminar",
      "API": {
        "SUCCESS_MESSAGE": "Etiqueta actualizada correctamente",
        "ERROR_MESSAGE": "Hubo un error, por favor inténtelo de nuevo",
        "IN_USE_ERROR": "Esta etiqueta no se puede eliminar porque se usa en {usages}. Elimínala primero de esos registros.",
        "IN_USE_FILTERS": "filtros: {names}",
        "IN_USE_AUTOMATIONS": "reglas de automatización: {names}",
        "IN_USE_MACROS": "macros: {names}"
      },
      "CONFIRM": {
        "TITLE": "Confirmar eliminación",
        "MESSAGE": "¿Está seguro de eliminar ",
        "YES": "Sí, eliminar ",
        "NO": "No, mantenerlo "
      }
    }
  }
}
